import React from "react";

export default function Dot(props) {
    const textStyle = {textAlign: 'left', marginBottom: '0', fontSize: '0.82vw'};

    return (
        <div>
            <span className={'dot'} style={{backgroundColor: props.color}}/>
            <p style={textStyle}>{props.name}: {props.value.toLocaleString()}</p>
        </div>
    )
}